import { useCallback } from 'react';
import { log } from 'log';
import { useSetPlayerTags } from 'server';

import { getCookie } from '@core/js/utils/cookie.util';

const useSendPOCTag = () => {
    const setPlayerTags = useSetPlayerTags();

    return useCallback(async (url: string): Promise<void> => {
        const date = new Date();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();

        const pocLogger = getCookie('pocLogger');

        const formattedHours = hours < 10 ? `0${hours}` : hours;
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
        const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

        const POCTag = [
            {
                expirationDate: '',
                name: 'Safebet/PageVisit',
                type: 'text',
                value: `${url.slice(1)}_${formattedHours}:${formattedMinutes}:${formattedSeconds}`
            }
        ];

        pocLogger && console.table(POCTag);

        try {
            await setPlayerTags({ tags: POCTag });
        } catch (error) {
            log('error', error);
        }
    }, [setPlayerTags]);
};

export default useSendPOCTag;
